import { render, staticRenderFns } from "./CardTarjaOlimpiadas.vue?vue&type=template&id=3abd6ca4&scoped=true"
import script from "./CardTarjaOlimpiadas.vue?vue&type=script&lang=js"
export * from "./CardTarjaOlimpiadas.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaOlimpiadas.vue?vue&type=style&index=0&id=3abd6ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abd6ca4",
  null
  
)

export default component.exports